@if (menuSidebarItem()) {
  <a [routerLink]="menuSidebarItem().route" class="w-full flex gap-2 p-2 rounded-lg hover:bg-black-900 hover:text-white duration-200" [ngClass]="isCurrent() ? 'bg-black-900 text-white' : ''">
    <div>
      <i class="text-lg fa-fw" [ngClass]="menuSidebarItem().iconClass" [pTooltip]="menuSidebarItem().label"></i>
    </div>
    <div class="hidden xl:inline text-nowrap truncate text-start text-sm">{{ menuSidebarItem().label }}</div>
  </a>
}
